export const termsOfDeliveriesConstants = {
  FCA: "FCA",
  Other: "Other"
};
